<template>
  <div class="about-pc">
    <h2>网络与设备检测</h2>
    <tab :active=1></tab>
    <div class="loading-wrap" v-if="percent <= 100">
      <el-progress type="circle" :percentage="percent" :stroke-width="12" :color="'#306FFF'"></el-progress>
      <p class="tip">正在检测您的设备与网络</p>
    </div>
    <div class="result" v-else>
      <div class="speed-ok flex-column-center" v-if="isPcCheckPass()">
        <p class="icon-speed-ok"></p>
        <p class="tip">你的设备与网络环境不错哦，可以正常答题～</p>
      </div>
      <div class="speed-bad flex-column-center" v-else>
        <p class="icon-speed-bad"></p>
        <p class="tip">设备与网络环境不佳，出现异常～</p>
      </div>
      <button class="btn" @click="nextStep">下一步</button>
    </div>
  </div>
</template>

<script>
import Tab from './Tab'
import { getDetectInfo } from '@/utils/detect'
// import { qiniuUpload } from '@/utils'
import { sdkUploader } from '@/utils/upload-sdk'
import { Progress } from 'element-ui'

export default {
  components: {
    Tab,
    ElProgress: Progress
  },
  data() {
    return {
      detectResource: 'https://education.codemao.cn/27/exam/1/detect/1596781871000/detect_pic.png',
      resBlob: {},
      percent: 0,
      minSpeed: 0.13,
      pcInfo: {
        uploadSpeed: 0,
        downloadSpeed: 0,
        browser: '',
        browserVersion: '',
        OS: '',
        osVersion: ''
      },
      timer: null
    }
  },
  async mounted() {
    this.getDownloadSpeed()
    const detectInfo = getDetectInfo()
    this.pcInfo = Object.assign(this.pcInfo, detectInfo)
    this.handleListenNetworkChange()
  },
  destroyed() {
    this.timer = null
  },
  methods: {
    // 获取下载速度
    getDownloadSpeed() {
      this.percent = 0
      const startTime = Date.now()
      const xhr = new XMLHttpRequest()
      const url = `${this.detectResource}?timeslot=${Date.now()}`
      xhr.open('GET', url, true)
      xhr.onload = (data) => {
        const duration = (Date.now() - startTime) / 1000
        const byte = Number(xhr.responseText.length)
        const size = this.byteToMbps(byte)
        const speed = Number((size / duration).toFixed(2))
        // 保证上传与下载资源大小一致
        const blobType = 'text/plain'
        const resBlob = new Blob([data.target.response], {
          type: blobType
        }).slice(0, byte, blobType)
        this.resBlob = resBlob
        this.speed = speed
        this.pcInfo.downloadSpeed = speed
        this.getUploadSpeed(resBlob)
      }
      xhr.onprogress = (data) => {
        const percent = data.loaded / data.total
        this.percent = Number((percent * 100 / 2).toFixed(2))
      }
      xhr.send()
    },
    byteToMbps(byte) {
      return byte / 1024 / 1024
    },
    uploadProgressCb(res) {
      this.percent = Number((50 + res.total.percent / 2).toFixed(2))
      if (res.total.percent === 100) {
        this.timer = null
        this.timer = setTimeout(() => {
          this.percent = 1000
        }, 500)
      }
    },
    uploadCb (res) {
      const duration = (Date.now() - this.uploadTime) / 1000
      const size = this.byteToMbps(this.resBlob.size)
      const speed = Number((size / duration).toFixed(2))
      this.pcInfo.uploadSpeed = speed
      this.$emit('setPcInfo', this.pcInfo)
    },
    errorCb(e) {
      console.log('get upload speed error', e)
    },
    // 获取上传速度
    async getUploadSpeed(blob) {
      this.uploadTime = Date.now()
      const file = new File([blob], 'testUploadSpeed', { type: blob.type, lastModified: Date.now() })
      try {
        await sdkUploader(file, {
          onprogress: this.uploadProgressCb
        })
        this.uploadCb()
      } catch (error) {
        this.errorCb()
      }
      this.nextStep()

      // qiniuUpload(file, {
      //   uploadCb: this.uploadCb,
      //   errorCb: this.errorCb,
      //   progressCb: this.uploadProgressCb,
      //   mimeType: [
      //     'image/png',
      //     'image/jpeg',
      //     'image/jpg',
      //     blob.type
      //   ]
      // })
    },
    isPcCheckPass() {
      if (this.speed <= this.minSpeed) {
        return false
      }

      if (this.pcInfo.browser !== 'Chrome') {
        return false
      }
      const version = +(this.pcInfo.browserVersion.split('/')[1])
      if (version < 78) {
        return false
      }

      return true
    },
    nextStep() {
      this.$emit('nextStep', 1)
    },
    handleListenNetworkChange() {
      window.addEventListener('online', this.handleNetworkOnline)
      window.addEventListener('offline', this.handleNetworkOffline)
    },
    handleNetworkOnline() {
      this.getDownloadSpeed()
    },
    handleNetworkOffline() {
      this.$message.error('网络异常，请检查网络连接')
    },
    handleRemoveNetworkChange() {
      window.removeEventListener('online', this.handleNetworkOnline)
      window.removeEventListener('offline', this.handleNetworkOffline)
    }
  },
  beforeDestroy() {
    this.handleRemoveNetworkChange()
  }
}
</script>

<style lang="scss" scoped>
  .loading-wrap {
    margin-top: 40px;
    .tip {
      padding-bottom: 144px;
    }
  }
  /deep/ .el-progress-circle {
    path:first-child {
      stroke: #E4F1FF !important;
    }
  }
  .result {
    margin-top: 36px;
  }
  .icon-speed-ok {
    width: 164px;
    height: 130px;
    background: url('~@/assets/images/detect/speed-ok.png') center / cover no-repeat;
  }
  .icon-speed-bad {
    width: 154px;
    height: 130px;
    background: url('~@/assets/images/detect/speed-bad.png') center / cover no-repeat;
  }
  .tip {
    color: $titleColor;
    margin-top: 10px;
    font-size: $baseTextSize;
  }
  .speed-bad {
    .tip {
      color: #FF5030;
    }
  }
  .btn {
    @include theme-fill-btn(144px, 42px, 16px, 4px);
    margin-top: 38px;
    margin-bottom: 84px;
  }
</style>
